import { Component, OnInit } from '@angular/core';

import { faBars } from '@fortawesome/free-solid-svg-icons';
import { IndicatorsService } from '../services/indicators.service';
import { CustomerService } from '../services/customer.service';
import { AppFormat } from '../appFormat';

const { getTreemap } = require('treemap-squarify');

@Component({
  selector: 'app-tv-dashboard',
  templateUrl: './tv-dashboard.component.html',
  styleUrls: ['./tv-dashboard.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class TvDashboardComponent implements OnInit {
  faBars = faBars

  public result: any
  public treemapWidth: number
  public treemapHeight: number
  public stores: any[]

  public loadingSales: boolean
  public loadingTotal: boolean

  public menuOpen: boolean

  public stats: any

  public evaluations: any[]

  private start_date: any

  private interval: any

  constructor(private _indicatorsService: IndicatorsService, private _customerService: CustomerService) {}

  ngOnInit(): void {
    this.start_date = new Date().getFullYear()+'-'+AppFormat.pad((new Date().getMonth()+1), 2)+'-'+AppFormat.pad(new Date().getDate(), 2)+' 00:00:00'

    this.interval = null
    this.evaluations = []
    this.stores = []
    this.stats = {
      orders: {
        total: 0,
        approved: 0,
        canceled: 0
      },
      sales: {
        total: 0,
        approved: 0,
        canceled: 0
      }
    }

    this.loadingSales = true
    this.loadingTotal = true

    this.treemapWidth = document.getElementById('chart').offsetWidth
    this.treemapHeight = document.getElementById('chart').offsetHeight

    setTimeout(()=>{

      this.loadStatsStores()

      this.interval = setInterval(()=>{
        this.loadStatsStores()
      }, 30000)

    }, 500)

    this.menuOpen = false
  }

  ngOnDestroy(): void {
    if (this.interval) clearInterval(this.interval)
  }

  loadStatsStores() {
    this._indicatorsService.getSalesOrdersStatistics().subscribe(res => {
      if (res['stats']) {
        this.stores = res['stats']
        this.genarateChart()
        this.loadingSales = false
      }
    })

    this._indicatorsService.getTotalSalesOrdersStatistics().subscribe(res => {
      if (res['success']) {
        this.stats = res['stats']
        this.loadingTotal = false
      }
    })

    this._customerService.getCustomersBadEvaluations(this.start_date).subscribe(res => {
      if (res['success']) {
        if (res['evaluations'] && res['evaluations'].length > 0) {
          for (let i in res['evaluations']) {
            this.evaluations.push(res['evaluations'][i])
          }
          this.start_date = new Date().getFullYear()+'-'+AppFormat.pad((new Date().getMonth()+1), 2)+'-'+AppFormat.pad(new Date().getDate(),2)+' '+AppFormat.pad(new Date().getHours(), 2)+':'+AppFormat.pad(new Date().getMinutes(),2)+':'+AppFormat.pad(new Date().getSeconds(),2)
        }
      }
    })
  }

  genarateChart() {
    this.result = getTreemap({
      data: this.stores,
      width: this.treemapWidth,
      height: this.treemapHeight
    });
  }

  onResize(event) {

    this.treemapWidth = document.getElementById('chart').offsetWidth
    this.treemapHeight = document.getElementById('chart').offsetHeight

    this.genarateChart()
  }

  toogleMenu() {
    this.menuOpen = !this.menuOpen
  }

}
